import React from 'react';
import ListingDetailsMap from './ListingDetails/components/ListingDetailsMap';
import PaymentCalculator from '../components/paymentCalculator';
import SalesHistoryTable from '../components/salesHistoryTable';
import SalesHistoryCard from '../components/salesHistoryCard';
import { replaceFontAwesome } from './ReportDetailsImage';
import {
    appendToken, formatBytes, formatDateTime,
    formatDateISO, formatOpenHouseDates, getFormattedCurrency, openHouseLiveStream, formatDate, getFormattedNumber
} from '../components/utils';
import { ReactComponent as SourceMLS } from '../images/icons/details-report/source-mls.svg';
import livestream from '../images/icons/livestream.svg';
import livestreamBlue from '../images/icons/livestream_blue.svg';
import Moment from 'moment';
import { Table } from 'reactstrap';

// --------------------------------------------------
// begin custom sections ----------------------------
// --------------------------------------------------
export const buildSalesHistorySection = (listing, isMobile) => {
    return <div key="saleshistory" id="Sales History" className="row mg-topbtm-40 txt-algn-lft">
        {isMobile ? <SalesHistoryCard listing={listing} /> : <SalesHistoryTable listing={listing} />}
    </div>
}

export const buildMap = (listing) => {
    if(!listing.Latitude || !listing.Longitude) return null;
    const mapListings = [listing];
    return <div key="map" id="Map">
        <div className="col-12 mg-topbtm-20 txt-algn-lft">
            <h3>{'Map'}</h3>
        </div>
        <ListingDetailsMap
            // ref={ref => this.esriMap = ref}
            properties={mapListings}
            resultsCount={mapListings.length}
            height={500}
            Latitude={listing.Latitude}
            Longitude={listing.Longitude}
            Zoom={17}
            bounceMarker={listing.Id}
            DisableScrollZoom={true}
            showMap
            doNotShowPopup
        />
    </div>
}

export const buildPaymentCalculator = (listing, liveMortgageUrlLink, callback) => {
    const mapListings = [listing];
    return <div>
        <div key="calculator" id="Payment Calculator" className="row mg-topbtm-40 txt-algn-lft">
            <div className="col-12 mg-topbtm-20">
                <h3>{'Payment Calculator'}</h3>
            </div>
            <PaymentCalculator
                properties={mapListings}
                liveMortgageUrlLink={liveMortgageUrlLink}
                onEstimatedPayment={callback}
            />
            <div className="col-12">
                <p className='mb-0'>
                    <i>
                        <b>Note:</b> This payment calculator is provided for informational purposes only. You should not make any decisions based simply on the information provided.
                        Values indicated are estimates, may not be accurate, and are only used as a guide. This payment calculator should not be relied upon in any way as the sole source of information.
                        Please consult your financial, tax, or legal advisers for an accurate assessment of your mortgage payments and any advice relating to your personal circumstances.
                    </i>
                </p>
            </div>
        </div>
        {listing.ReportType === "clientlivemortgagerates" && <div key="lmr" id="Live Mortgage Rates" className="row mg-topbtm-40 txt-algn-lft">
            <div className="col-12 mg-topbtm-20">
                <h3>{'Live Mortgage Rates'}</h3>
            </div>
            <iframe src={listing.LiveMortgageRateEmbeddedUrl} frameborder="0" width="100%" height="270" title="live-mortage-rates"></iframe>
        </div>}
    </div>
}

export const buildAdditionalInfoSection = (tools, reports, url) => {
    const reportsHeader = reports && reports.length > 0 ? <div className="col-12 mg-topbtm-16"><h5>Reports</h5></div> : null;
    const toolsHeader = tools && tools.length > 0 ? <div className="col-12 mg-topbtm-16"><h5>Tools</h5></div> : null;
    const splitArrayReports = reports ? splitToChunks(reports, 2) : null;
    const splitArrayTools = tools ? splitToChunks(tools, 2) : null;

    return <div key="additionalinfo" id="Additional Info" className="row mg-topbtm-40 txt-algn-lft">
        <div className="col-12 mg-topbtm-20"><h3>Additional Info</h3></div>
        {reportsHeader}
        {splitArrayReports && splitArrayReports.map((column, i) => {
            return <div key={i} className={splitArrayReports.length > 1 ? "col-md-6" : "col-md-12"}>
                {column.map((obj, j) => {
                    let html = replaceFontAwesome(obj, false, true, url)
                    return html ? <div key={j} className="listing-details-row" dangerouslySetInnerHTML={{ __html: html }} /> : null
                })}
            </div>
        })}
        {toolsHeader}
        {splitArrayTools && splitArrayTools.map((column, i) => {
            return <div key={i} className={splitArrayTools.length > 1 ? "col-md-6" : "col-md-12"}>
                {column.map((obj, j) => {
                    let html = replaceFontAwesome(obj, false, true, url)
                    return html ? <div key={j} className="listing-details-row" dangerouslySetInnerHTML={{ __html: html }} /> : null
                })}
            </div>
        })}
    </div>
}

export const buildLiveMortgageUrlLink = (tools) => {
    if (!tools) return null;
    const ratePlugLink = tools.links.filter(l => l.name === 'ratePlugLink');
    if (ratePlugLink.length > 0)
        return ratePlugLink[0].html;

    return null;
}

export const buildDocumentsReportTable = (listing) => {
    if (!listing.PublicDocuments || window.location.pathname.includes("public")) return null;
    const splitArray = listing.PublicDocuments.length > 5 ?
        splitToChunks([...listing.PublicDocuments], 2) : [listing.PublicDocuments]

    return (
        <div key="documents" className="row mg-topbtm-40 txt-algn-lft">
            <div className="col-12 mg-topbtm-16"><h5>Documents</h5></div>
            {splitArray.map((column, i) => {
                return <div key={i} className={splitArray.length > 1 ? "col-md-6" : "col-md-12"}>
                    <table className="listing-details-table">
                        <thead>
                            <tr style={{ borderBottom: '1px solid #555555' }}>
                                <th>File Name</th>
                                <th>Size</th>
                                <th className="d-none d-xl-block txt-algn-rt" style={{ minWidth: '154px' }}>Date</th>
                                <th className="d-xl-none txt-algn-rt">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {column.map((obj, j) => {
                                return <tr key={j}>
                                    <td>
                                        <button key={j} className="btn-link"
                                            onClick={() => window.open(appendToken(obj.Url))}>{obj.Name}</button>
                                    </td>
                                    <td style={{ width: '52px', textAlign: 'left' }}>
                                        {formatBytes(obj.Size)}
                                    </td>
                                    <td className="d-none d-xl-block txt-algn-rt" style={{ minWidth: '154px' }}>
                                        {formatDateTime(obj.PostDate)}
                                    </td>
                                    <td className="d-xl-none txt-algn-rt">
                                        {formatDateISO(obj.PostDate)}
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            })}
        </div>
    )
}

const VALUE_RENDERER = {
    number: (value) => getFormattedNumber(value),
    date: (value) => formatDate(value),
    currency: (value) => getFormattedCurrency(value),
    default: (value) => value,
};

export const buildRoomInformation = (section) => {
    const { Column1, Column2, Column3 } = section;
    const allColumns = [...(Column1 ?? []), ...(Column2 ?? []), ...(Column3 ?? [])];
    const headerTitles = allColumns.map(({ Label }) => Label);
    const totalRows = allColumns[0]?.Value?.length;
    const rows = [...Array(totalRows).keys()];

    const renderHeader = (headerTitle) => {
        return <th key={headerTitle} className="listing-details-key">{headerTitle}</th>
    }
    const renderColumn = (column, rowIndex, columnIndex) => {
        const type = column.Type;
        const renderer = VALUE_RENDERER[type] ?? VALUE_RENDERER.default;
        const value = renderer(column.Value?.[rowIndex] ?? '');
        return <td key={`column_${rowIndex}_${columnIndex}`}>{value}</td>
    }
    const renderRow = (rowNumber) => {
        return <tr key={`row_${rowNumber}`}>{allColumns.map((column, columnIndex) => renderColumn(column, rowNumber, columnIndex))}</tr>;
    }

    return <div id={section.Title} className="row mg-topbtm-40 txt-algn-lft">
        <div className="col-12 mg-topbtm-16"><h3>{section.Title}</h3></div>
        <div className={"col-md-12 table-responsive"}>
            <Table size="sm">
                <thead>
                    <tr>
                        {headerTitles.map(renderHeader)}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(renderRow)}
                </tbody>
            </Table>
        </div>
    </div>
}

export const buildLevelInformation = (section) => {
    const { Column1: rows, Title } = section;

    const headerTitles = ["Level", "Full Baths", "Half Baths", "Bedrooms", "Rooms"];

    const renderHeader = (headerTitle) => {
        return <th key={headerTitle} className="listing-details-key">{headerTitle}</th>
    }
    const renderRow = ({ Id, Label, Value }) => {
        return <tr key={`row_${Id}`}>
            <td>{Label}</td>
            <td>{Value.FULL_BATHS}</td>
            <td>{Value.HALF_BATHS}</td>
            <td>{Value.BED_ROOMS}</td>
            <td>{Value.ROOMS}</td>
        </tr>;
    }

    const totalRow = rows.filter(row => row.Id !== 'MU_LEVEL_DETAILS').map(({ Value }) => Value).reduce((acc, value) => {
        return {
            ...acc,
            Value: {
                FULL_BATHS: acc.Value.FULL_BATHS + parseInt(value.FULL_BATHS, 10),
                HALF_BATHS: acc.Value.HALF_BATHS + parseInt(value.HALF_BATHS, 10),
                BED_ROOMS: acc.Value.BED_ROOMS + parseInt(value.BED_ROOMS, 10),
                ROOMS: acc.Value.ROOMS + parseInt(value.ROOMS, 10)
            }
        }
    }, { Id: "TotalLevelRow", Label: "Total", Value: { FULL_BATHS: 0, HALF_BATHS: 0, BED_ROOMS: 0, ROOMS: 0 } });

    return <div id={Title} className="row mg-topbtm-40 txt-algn-lft">
        <div className="col-12 mg-topbtm-16"><h3>{Title}</h3></div>
        <div className={"col-md-12 table-responsive"}>
            <Table size="sm">
                <thead>
                    <tr>
                        {headerTitles.map(renderHeader)}
                    </tr>
                </thead>
                <tbody>
                    {rows.map(renderRow)}
                </tbody>
                <tfoot>
                    {renderRow(totalRow)}
                </tfoot>
            </Table>
        </div>
    </div>
}

export const buildUnitInformation = buildRoomInformation;
export const buildUnits = buildRoomInformation;

export const buildAlqInformation = (section) => {
    const { Column1, Column2, Title } = section;
    const numAlq = Column1?.[0]?.Value?.length ?? 0;

    if (numAlq === 0) return null;

    const renderFieldValue = (field, alqIndex) => {
        const type = field.Type;
        const renderer = VALUE_RENDERER[type] ?? VALUE_RENDERER.default;
        return renderer(field.Value?.[alqIndex] ?? '');
    };

    const renderColumn = (fields, alqIndex, colKey) => (
        <div className="col-md-6" key={colKey}>
            {(fields ?? []).map((field) => (
                <div className="listing-details-row" key={`${field.Id}_${alqIndex}`}>
                    <div className="listing-details-key">{field.Label}</div>
                    <div className="listing-details-value">{renderFieldValue(field, alqIndex)}</div>
                </div>
            ))}
        </div>
    );

    const renderAlqBlock = (alqIndex) => (
        <div key={`alq_${alqIndex}`} className="col-12 mg-btm-24">
            <h5 className="mg-topbtm-16">{`${Title} ${alqIndex + 1}`}</h5>
            <div className="row">
                {renderColumn(Column1, alqIndex, `col1_${alqIndex}`)}
                {renderColumn(Column2, alqIndex, `col2_${alqIndex}`)}
            </div>
        </div>
    );

    return (
        <div id={Title} className="row mg-topbtm-40 txt-algn-lft">
            <div className="col-12 mg-topbtm-16"><h3>{Title}</h3></div>
            {Array.from({ length: numAlq }, (_, i) => renderAlqBlock(i))}
        </div>
    );
};

// --------------------------------------------------
// begin utils --------------------------------------
// --------------------------------------------------
function splitToChunks(array, parts) {
    let result = [];
    for (let i = parts; i > 0; i--) {
        result.push(array.splice(0, Math.ceil(array.length / i)));
    }
    return result;
}

export const buildComingSoonBar = (listing, hideLabel, isFeed) => {
    if (!listing || !listing.ExpectedActiveDate || listing.OpenHouses || listing.MlsStatusDisplay !== 'CS') return null;
    let comingSoonTime = new Moment(listing.ExpectedActiveDate).format('ddd MMM D');
    const label = hideLabel ? '' : 'Coming Soon ';
    if (comingSoonTime) {
        return <div className="coming-soon-time">{label}{comingSoonTime}</div>
    }
    return null;
}

export const buildOpenHouseBar = (listing, hideLabel, isFeed) => {
    if (!listing) return null;
    let openHouseTime = formatOpenHouseDates(listing);
    let openHouseLS = openHouseLiveStream(listing);
    const label = hideLabel ? '' : 'Open House ';
    if (openHouseTime) {
        return (openHouseLS && !isFeed) ?
            <div className="open-house-time">
                <a href={openHouseLS} onClick={e => e.stopPropagation()} style={{ color: '#fff' }} target="_blank" rel="noopener noreferrer">
                    <img src={livestream} className="pd-rt-8" alt="Live Stream Link" />{label}{openHouseTime}
                </a>
            </div>
            : <div className="open-house-time">{label}{openHouseTime}</div>
    }
    return null;
}

export const buildLiveStreamBadge = (listing) => {
    if (!listing) return null;
    let openHouseLS = openHouseLiveStream(listing);

    return openHouseLS ? <div className="open-house-badge">
        <a href={openHouseLS} onClick={e => e.stopPropagation()} target="_blank" rel="noopener noreferrer">
            OPEN HOUSE <img src={livestreamBlue} alt="Live Stream Link" />
        </a>
    </div> : <div className="open-house-badge">OPEN HOUSE</div>
}

export const displayListingPrice = (listing, formatLabel) => {
    const auctionPrice = listing.MlsStatus === 'Auction' ? listing.OpeningBidOrReseverPrice : listing.LastListPrice;
    const auctionLabel = formatLabel ?
        <span>
            <div>
                {listing.PriceTypeLabel + " "}
            </div>
            <div>
                {getFormattedCurrency(auctionPrice)}
            </div>
        </span> : listing.PriceTypeLabel + " " + getFormattedCurrency(auctionPrice);

    return listing.PriceTypeLabel ? auctionLabel :
        (listing.ClosePrice ? getFormattedCurrency(listing.ClosePrice) :
            (listing.ListPriceLow ? getFormattedCurrency(listing.ListPriceLow) + " - " : "") +
            getFormattedCurrency(listing.ListPrice || listing.RentalPrice))
}

export const sourceMLSButton = <div key="sourceMLSButton" className="mg-sides-0 row txt-algn-lft mg-top-16">
    <div className="col-12">
        <a href="http://www.sourcemls.org/" aria-label="Source MLS" target="_blank" rel="noopener noreferrer"><SourceMLS /></a>
    </div>
</div>
